export const baseUrl =
  process.env.REACT_APP_STRAPI_URL || "https://admin.go-te.co";
